module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAARVBMVEUAAABniMxniM1miM1nh8xliMxmh8tnh8xmh8xmiMyCndWGodeUq9umueKmuuGxwuWxwua0xebCz+vR2/Df5vTx9Pr////iwECUAAAACXRSTlMAmqmss73D1+g694G4AAAAAWJLR0QWfNGoGQAAAK1JREFUaN7t27sOglAQRdHxzSiKCvr/n2ptATHy0rBOexNWNcluiFjgdsUI2287FxERRU6/BcNVPeBOmXltf36D6+eAK7s/CAaDwWAwuB1uyl67fQ3X/WqmBH8MP/olXuOcwGAwGAz+Y3i2EBB7k8GzBb07BoPBYDAYrKt1ta7W1WAwGAwGg8GCXlcLencMBoPB4J+BL/cBd8zMc/vzwn/CmQVeH0bYZtW5sOn2AvFOz/fFS1nMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/side.png
// module id = 7mGB
// module chunks = 1